import { hMacAjax } from '../httpService';
import { userCenterAPI } from '@/httpService/serviceApi';
//获取登录成功后跳转地址和主动退出跳转的地址
export const getLoginAndOutGoPath = () => {
    return hMacAjax.get(userCenterAPI + '/user/third/config/v1/login-logout');
};
//获取专属门户配置,在点击登录时判断跳转到哪
export const getSpecialPortal = (portalId) => {
    return hMacAjax.get(userCenterAPI + '/open/user/third/config/v1/portal/' + portalId);
};
